
import { IUserSession } from '../../../helpers/user-session'

import { TaskTypeCreateEditController } from './tasks-types-create-edit.directive.controller'

import { TaskTypeHelper } from '../tasks-types.helper'

//#region Asset Imports

import * as TEMPLATE from './tasks-types-create-edit.tpl.html'

//#endregion

// Setup

export class TaskTypeCreateEditDirective implements ng.IDirective {

    restrict = 'E'

    controller = ['$scope', '$q', '$timeout', 'userSession', (
            $scope: any, 
            $q: ng.IQService, 
            $timeout: ng.ITimeoutService, 
            userSession: IUserSession
        ) => new TaskTypeCreateEditController(
            $scope, 
            $q, 
            $timeout, 
            userSession,
            TaskTypeHelper.REFERENCE_TYPE,
            TaskTypeHelper.SIMAX_MODULE_NAME 
        )]
            
    template = TEMPLATE
}

// Setup End